import type { OAuthLoginParams, OAuthResponse, ProfileParams } from '@/api/schema'
import { UI } from '@/app/components/UI/UI'
import GoogleSvg from '@/app/icons/google.svg?react'
import VkSvg from '@/app/icons/vk.svg?react'
import YandexSvg from '@/app/icons/yandex.svg?react'
import { api } from '@/app/utils/api'
import { metrikaGoal } from '@/app/utils/metrika'
import type { FunctionalComponent } from 'preact'
import { useState } from 'preact/hooks'

export const OAuthBtn: FunctionalComponent<
  {
    provider: 'vk' | 'yandex' | 'google'
    from?: string
    profile?: ProfileParams
  }
> = props => {
  const { provider, from, profile } = props

  const [loading, setLoading] = useState(false)

  return (
    <UI.Button
      type='secondary'
      disabled={loading}
      onClick={async () => {
        try {
          let metrika = 'login_google'
          if (provider === 'vk') {
            metrika = 'login_vk'
          }
          if (provider === 'yandex') {
            metrika = 'login_yandex'
          }

          let apiUrl = '/login/google'
          if (provider === 'vk') {
            apiUrl = '/login/vk'
          }
          if (provider === 'yandex') {
            apiUrl = '/login/yandex'
          }

          setLoading(true)
          metrikaGoal(metrika)
          const resp = await api.post<OAuthResponse>(
            apiUrl,
            {
              from,
              profile,
            } satisfies OAuthLoginParams,
          )
          window.location.href = resp.data.redirectUrl
        }
        catch (e) {
          console.error(e)
          // TODO: Errors
          // setErrors(parseError(e))
        }
        finally {
          setLoading(false)
        }
      }}
    >
      {props.provider === 'google'
        ? <GoogleSvg width={24} height={24} />
        : props.provider === 'vk'
        ? <VkSvg width={24} height={24} />
        : props.provider === 'yandex'
        ? <YandexSvg />
        : null}
    </UI.Button>
  )
}
